webpackJsonp([79611799117203,60335399758886],{

/***/ 254:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(455);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(254);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports._Modal = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(243);
	
	var _reactBootstrap = __webpack_require__(55);
	
	__webpack_require__(244);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _Modal = function _Modal(_ref) {
		var direction = _ref.direction,
		    className = _ref.className,
		    otherProps = _objectWithoutProperties(_ref, ["direction", "className"]);
	
		if (direction === "left") {
			className = className ? className + " left" : "left";
		} else if (direction === "right") {
			className = className ? className + " right" : "right";
		}
		return _react2.default.createElement(_reactBootstrap.Modal, _extends({}, otherProps, { className: className }));
	};
	
	exports._Modal = _Modal;
	_Modal.propTypes = {
		direction: _propTypes2.default.string,
		className: _propTypes2.default.string
	};
	
	_Modal.Header = _reactBootstrap.Modal.Header;
	_Modal.Body = _reactBootstrap.Modal.Body;
	_Modal.Footer = _reactBootstrap.Modal.Footer;
	_Modal.Title = _reactBootstrap.Modal.Title;
	
	exports.default = _Modal;

/***/ }),

/***/ 243:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Modal = __webpack_require__(199);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 625:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Sidebar = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Modal = __webpack_require__(200);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	__webpack_require__(625);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = exports.Sidebar = function (_React$Component) {
	  _inherits(Sidebar, _React$Component);
	
	  function Sidebar() {
	    _classCallCheck(this, Sidebar);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Sidebar.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        onHide = _props.onHide,
	        Menu = _props.Menu,
	        activePathname = _props.activePathname;
	
	    return _react2.default.createElement(
	      _Modal2.default,
	      { direction: "right", className: "sidebar", show: show, onHide: onHide },
	      _react2.default.createElement(
	        _Modal2.default.Header,
	        null,
	        _react2.default.createElement(
	          "span",
	          { className: "cross" },
	          _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	        )
	      ),
	      _react2.default.createElement(
	        _Modal2.default.Body,
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "tabs" },
	          _react2.default.createElement(
	            "ul",
	            { className: "" },
	            Menu.map(function (item) {
	              return _react2.default.createElement(
	                "li",
	                {
	                  key: item.title,
	                  onClick: onHide,
	                  className: "menu__text" + ("/" + activePathname === item.link ? "-active" : "")
	                },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: item.link },
	                  item.title
	                )
	              );
	            }),
	            _react2.default.createElement(
	              "div",
	              { className: "social__header" },
	              _react2.default.createElement(
	                "div",
	                { className: "social__icons" },
	                _react2.default.createElement(
	                  "span",
	                  { className: "icon" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      rel: "noopener noreferrer",
	                      href: "https://www.facebook.com/bawamasalacompany",
	                      target: "_blank",
	                      className: ""
	                    },
	                    _react2.default.createElement("i", { className: "fa-brands fa-facebook" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "icon" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      rel: "noopener noreferrer",
	                      href: "https://www.instagram.com/bawamasalacompany/",
	                      target: "_blank",
	                      className: ""
	                    },
	                    _react2.default.createElement("i", { className: "fa-brands fa-instagram" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "icon" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      rel: "noopener noreferrer",
	                      href: "https://twitter.com/bawamasalaco",
	                      target: "_blank",
	                      className: ""
	                    },
	                    _react2.default.createElement("i", { className: "fa-brands fa-x-twitter" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "icon" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      rel: "noopener noreferrer",
	                      href: "https://www.linkedin.com/company/18855306/admin/overview/",
	                      target: "_blank",
	                      className: ""
	                    },
	                    _react2.default.createElement("i", { className: "fa-brands fa-linkedin" })
	                  )
	                ),
	                _react2.default.createElement(
	                  "span",
	                  { className: "icon" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      rel: "noopener noreferrer",
	                      href: "https://www.youtube.com/channel/UCWX7VFCNfrmjeXaAqYtyoQA?view_as=subscriber",
	                      target: "_blank",
	                      className: ""
	                    },
	                    _react2.default.createElement("i", { className: "fa-brands fa-youtube" })
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Sidebar;
	}(_react2.default.Component);
	
	Sidebar.propTypes = {
	  show: _propTypes2.default.bool,
	  onHide: _propTypes2.default.func,
	  activePathname: _propTypes2.default.string,
	  Menu: _propTypes2.default.array
	};
	
	exports.default = Sidebar;

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Sidebar = __webpack_require__(452);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Sidebar2.default;
	module.exports = exports["default"];

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var validationForEmail = function validationForEmail(email) {
		// eslint-disable-next-line
		var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return emailRegex.test(email);
	};
	
	exports.validationForEmail = validationForEmail;

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.PageLayout = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(641);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Sidebar = __webpack_require__(453);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _reactRedux = __webpack_require__(78);
	
	var _createStore = __webpack_require__(500);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(622);
	
	var _reactFacebookPixel = __webpack_require__(32);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _regex = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var store = (0, _createStore2.default)();
	
	// Constants
	var LOGOS = {
	  header: "https://bawamasalacompany.com/assets/images/logo-dark.png",
	  mobile: "https://bawamasalacompany.com/assets/images/logo-dark.png",
	  footer: "https://bawamasalacompany.com/assets/images/BE(LOGO)footer200x200.png"
	};
	
	var SOCIAL_LINKS = [{ icon: "fa-facebook", url: "https://www.facebook.com/bawamasalacompany" }, { icon: "fa-instagram", url: "https://www.instagram.com/bawamasalacompany/" }, { icon: "fa-x-twitter", url: "https://twitter.com/bawamasalaco" }, { icon: "fa-linkedin", url: "https://www.linkedin.com/company/18855306/admin/overview/" }, { icon: "fa-youtube", url: "https://www.youtube.com/channel/UCWX7VFCNfrmjeXaAqYtyoQA?view_as=subscriber" }];
	
	var NAVIGATION_MENU = [{ title: "Home", link: "/" }, { title: "Products", link: "/store" }, { title: "Legacy", link: "/legacy" }, { title: "Dealerships", link: "/dealers" }, { title: "Masala Dabba", link: "/recipes" }, { title: "Contact", link: "/connect" }];
	
	var POPUP_TIMEOUT = 43200000; // 12 hours
	
	var PageLayout = exports.PageLayout = function (_React$Component) {
	  _inherits(PageLayout, _React$Component);
	
	  function PageLayout(props) {
	    _classCallCheck(this, PageLayout);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addScrollListener = function () {
	      window.addEventListener("scroll", _this.handleScroll, { passive: true });
	    };
	
	    _this.removeScrollListener = function () {
	      window.removeEventListener("scroll", _this.handleScroll);
	    };
	
	    _this.handleScroll = function () {
	      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	      var shouldBeScrolled = scrollTop > 100; // Increased threshold for better UX
	
	      if (shouldBeScrolled !== _this.state.isScrolled) {
	        _this.setState({ isScrolled: shouldBeScrolled });
	      }
	    };
	
	    _this.initializePixelTracking = function () {
	      var location = _this.props.location;
	
	      _reactFacebookPixel2.default.init("145006083100066");
	      _reactFacebookPixel2.default.track("ViewContent", location);
	    };
	
	    _this.initializeCart = function () {
	      var dispatch = store.dispatch;
	
	      var defaultCart = { products: {}, totalNumber: 0 };
	
	      var storedCart = localStorage.getItem("cart");
	      if (storedCart) {
	        var parsedCart = JSON.parse(storedCart);
	        if (parsedCart.products && parsedCart.totalNumber !== undefined) {
	          dispatch({ type: "SET_TO_CART", addToCartList: parsedCart });
	        } else {
	          _this.setDefaultCart(dispatch, defaultCart);
	        }
	        _this.setState({ cartNumber: store.getState().addToCartList.totalNumber });
	      } else {
	        _this.setDefaultCart(dispatch, defaultCart);
	      }
	    };
	
	    _this.setDefaultCart = function (dispatch, cart) {
	      dispatch({ type: "SET_TO_CART", addToCartList: cart });
	      localStorage.setItem("cart", JSON.stringify(cart));
	    };
	
	    _this.checkPopupDisplay = function () {
	      var popupShown = localStorage.getItem("popupShown");
	
	      if (!popupShown) {
	        _this.showPopup();
	      } else {
	        var _JSON$parse = JSON.parse(popupShown),
	            timestamp = _JSON$parse.timestamp;
	
	        var timeDiff = new Date() - new Date(timestamp);
	
	        if (timeDiff > POPUP_TIMEOUT) {
	          _this.showPopup();
	        }
	      }
	    };
	
	    _this.showPopup = function () {
	      _this.setState({ show: true }, function () {
	        var data = { timestamp: new Date() };
	        localStorage.setItem("popupShown", JSON.stringify(data));
	      });
	    };
	
	    _this.fetchUserLocation = function () {
	      var dispatch = store.dispatch;
	
	
	      _axios2.default.get("https://extreme-ip-lookup.com/json/").then(function (response) {
	        var data = response.data;
	
	        _this.regionName = data.region;
	        dispatch({ type: "SET_MACHINE_ADDRESS", ipData: data });
	        _this.setState({ findingRegion: true });
	      }).catch(function (error) {
	        console.error("Failed to fetch location:", error);
	        _this.setState({ findingRegion: true });
	      });
	    };
	
	    _this.toggleSidebar = function () {
	      _this.setState(function (prevState) {
	        return { isShowSidebar: !prevState.isShowSidebar };
	      });
	    };
	
	    _this.toggleModal = function () {
	      _this.setState(function (prevState) {
	        return { show: !prevState.show };
	      });
	    };
	
	    _this.handleEmailChange = function (e) {
	      _this.setState({ subscriberEmail: e.target.value, emailError: false });
	    };
	
	    _this.submitEmail = function () {
	      var subscriberEmail = _this.state.subscriberEmail;
	
	
	      if (!(0, _regex.validationForEmail)(subscriberEmail)) {
	        _this.setState({ emailError: "Please enter a valid email address" });
	        return;
	      }
	
	      _this.setState({ emailError: false, isSubmittingEmail: true });
	
	      var emailParams = "email=" + subscriberEmail + "&coupon=1";
	      var apiUrl = "https://blackelephantdigital.in/blackele/sunny/api/bmc-api/public/newsletter_subscriberBMC?" + emailParams;
	
	      _axios2.default.get(apiUrl).then(function (response) {
	        var data = response.data;
	
	        if (data === "Success") {
	          _this.setState({ isSubmitted: true, isSubmittingEmail: false });
	        } else {
	          _this.setState({
	            emailError: "This email is already subscribed",
	            isSubmittingEmail: false
	          });
	        }
	      }).catch(function () {
	        _this.setState({
	          emailError: "Failed to subscribe. Please try again.",
	          isSubmittingEmail: false
	        });
	      });
	    };
	
	    _this.toggleEnquiryForm = function () {
	      _this.setState(function (prevState) {
	        return {
	          showEnquiryForm: !prevState.showEnquiryForm,
	          enquirySubmitted: false,
	          enquiryErrors: {},
	          enquiryForm: {
	            fullName: "",
	            mobile: "",
	            address: "",
	            purpose: "",
	            message: ""
	          }
	        };
	      });
	    };
	
	    _this.handleEnquiryInputChange = function (e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      _this.setState(function (prevState) {
	        var _extends2, _extends3;
	
	        return {
	          enquiryForm: _extends({}, prevState.enquiryForm, (_extends2 = {}, _extends2[name] = value, _extends2)),
	          enquiryErrors: _extends({}, prevState.enquiryErrors, (_extends3 = {}, _extends3[name] = "", _extends3))
	        };
	      });
	    };
	
	    _this.validateEnquiryForm = function () {
	      var enquiryForm = _this.state.enquiryForm;
	
	      var errors = {};
	
	      if (!enquiryForm.fullName.trim()) {
	        errors.fullName = "Full name is required";
	      }
	
	      if (!enquiryForm.mobile.trim()) {
	        errors.mobile = "Mobile number is required";
	      } else if (!/^[0-9]{10}$/.test(enquiryForm.mobile.replace(/\s/g, ""))) {
	        errors.mobile = "Please enter a valid 10-digit mobile number";
	      }
	
	      if (!enquiryForm.address.trim()) {
	        errors.address = "Address is required";
	      }
	
	      if (!enquiryForm.purpose) {
	        errors.purpose = "Please select purpose of enquiry";
	      }
	
	      if (!enquiryForm.message.trim()) {
	        errors.message = "Message is required";
	      }
	
	      return errors;
	    };
	
	    _this.submitEnquiryForm = function () {
	      var errors = _this.validateEnquiryForm();
	
	      if (Object.keys(errors).length > 0) {
	        _this.setState({ enquiryErrors: errors });
	        return;
	      }
	
	      _this.setState({ isSubmittingEnquiry: true, enquiryErrors: {} });
	
	      var enquiryForm = _this.state.enquiryForm;
	
	      var formData = new FormData();
	      formData.append("full_name", enquiryForm.fullName);
	      formData.append("mobile", enquiryForm.mobile);
	      formData.append("address", enquiryForm.address);
	      formData.append("purpose", enquiryForm.purpose);
	      formData.append("message", enquiryForm.message);
	
	      // Replace with your actual API endpoint
	      var apiUrl = "https://bawamasalacompany.com/api/public/index.php/quickenquiry";
	
	      _axios2.default.post(apiUrl, formData).then(function (response) {
	        _this.setState({
	          enquirySubmitted: true,
	          isSubmittingEnquiry: false
	        });
	        setTimeout(function () {
	          _this.toggleEnquiryForm();
	        }, 2000);
	      }).catch(function (error) {
	        console.error("Failed to submit enquiry:", error);
	        _this.setState({
	          enquiryErrors: { submit: "Failed to submit enquiry. Please try again." },
	          isSubmittingEnquiry: false
	        });
	      });
	    };
	
	    _this.showEnquiryFormDelayed = function () {
	      // Show enquiry form after 3 seconds on all devices
	      setTimeout(function () {
	        _this.setState({ showEnquiryForm: true });
	      }, 3000);
	    };
	
	    _this.renderEnquiryPopup = function () {
	      var _this$state = _this.state,
	          showEnquiryForm = _this$state.showEnquiryForm,
	          isSubmittingEnquiry = _this$state.isSubmittingEnquiry,
	          enquiryForm = _this$state.enquiryForm,
	          enquiryErrors = _this$state.enquiryErrors,
	          enquirySubmitted = _this$state.enquirySubmitted;
	
	
	      var purposeOptions = [{ value: "", label: "Select Purpose" }, { value: "wholesale", label: "Bulk / Wholesale Purchase" }, { value: "distributor", label: "Distributor Enquiry" }, { value: "retail", label: "Retail Purchase" }, { value: "feedback", label: "Feedback / Other" }];
	
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "enquiry__slide_panel " + (showEnquiryForm ? "enquiry__slide_panel--open" : ""),
	          onClick: !showEnquiryForm ? _this.toggleEnquiryForm : undefined
	        },
	        _react2.default.createElement(
	          "div",
	          { className: "enquiry__panel_content", onClick: function onClick(e) {
	              return e.stopPropagation();
	            } },
	          _react2.default.createElement(
	            "div",
	            { className: "cross__icon", onClick: _this.toggleEnquiryForm },
	            _react2.default.createElement("i", { className: "fa fa-times" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "enquiry__form_wrapper" },
	            enquirySubmitted ? _react2.default.createElement(
	              "div",
	              { className: "success-message" },
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Thank You!"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Your enquiry has been submitted successfully. We will get back to you soon."
	              )
	            ) : _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "h3",
	                null,
	                "Quick Enquiry"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "enquiry__description" },
	                "Get in touch with us for all your spice needs!"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-group" },
	                _react2.default.createElement("input", {
	                  type: "text",
	                  name: "fullName",
	                  placeholder: "Full Name *",
	                  value: enquiryForm.fullName,
	                  onChange: _this.handleEnquiryInputChange,
	                  className: "form-control " + (enquiryErrors.fullName ? "error" : "")
	                }),
	                enquiryErrors.fullName && _react2.default.createElement(
	                  "div",
	                  { className: "error-text" },
	                  enquiryErrors.fullName
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-group" },
	                _react2.default.createElement("input", {
	                  type: "tel",
	                  name: "mobile",
	                  placeholder: "Mobile Number *",
	                  value: enquiryForm.mobile,
	                  onChange: _this.handleEnquiryInputChange,
	                  className: "form-control " + (enquiryErrors.mobile ? "error" : "")
	                }),
	                enquiryErrors.mobile && _react2.default.createElement(
	                  "div",
	                  { className: "error-text" },
	                  enquiryErrors.mobile
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-group" },
	                _react2.default.createElement("textarea", {
	                  name: "address",
	                  placeholder: "Address *",
	                  value: enquiryForm.address,
	                  onChange: _this.handleEnquiryInputChange,
	                  className: "form-control " + (enquiryErrors.address ? "error" : ""),
	                  rows: "2"
	                }),
	                enquiryErrors.address && _react2.default.createElement(
	                  "div",
	                  { className: "error-text" },
	                  enquiryErrors.address
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-group" },
	                _react2.default.createElement(
	                  "select",
	                  {
	                    name: "purpose",
	                    value: enquiryForm.purpose,
	                    onChange: _this.handleEnquiryInputChange,
	                    className: "form-control " + (enquiryErrors.purpose ? "error" : "")
	                  },
	                  purposeOptions.map(function (option) {
	                    return _react2.default.createElement(
	                      "option",
	                      { key: option.value, value: option.value },
	                      option.label
	                    );
	                  })
	                ),
	                enquiryErrors.purpose && _react2.default.createElement(
	                  "div",
	                  { className: "error-text" },
	                  enquiryErrors.purpose
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "form-group" },
	                _react2.default.createElement("textarea", {
	                  name: "message",
	                  placeholder: "Message *",
	                  value: enquiryForm.message,
	                  onChange: _this.handleEnquiryInputChange,
	                  className: "form-control " + (enquiryErrors.message ? "error" : ""),
	                  rows: "3"
	                }),
	                enquiryErrors.message && _react2.default.createElement(
	                  "div",
	                  { className: "error-text" },
	                  enquiryErrors.message
	                )
	              ),
	              enquiryErrors.submit && _react2.default.createElement(
	                "div",
	                { className: "error-text" },
	                enquiryErrors.submit
	              ),
	              _react2.default.createElement(
	                "button",
	                { onClick: _this.submitEnquiryForm, disabled: isSubmittingEnquiry, className: "enquiry-submit-btn" },
	                isSubmittingEnquiry ? "Submitting..." : "Submit Enquiry"
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderHeader = function (route) {
	      var isScrolled = _this.state.isScrolled;
	
	
	      return _react2.default.createElement(
	        "div",
	        { className: "page-layout__viewport__header " + (isScrolled ? "page-layout__viewport__header--scrolled" : "") },
	        _react2.default.createElement(
	          "div",
	          { className: "header__logo " + (isScrolled ? "header__logo--scrolled" : "") },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: "/" },
	            _react2.default.createElement("img", { src: LOGOS.header, alt: "BMC Logo", className: "img img-responsive" })
	          )
	        ),
	        _react2.default.createElement(
	          "nav",
	          { className: "menu__bar" },
	          _react2.default.createElement(
	            "ul",
	            null,
	            NAVIGATION_MENU.map(function (item) {
	              return _react2.default.createElement(
	                "li",
	                { key: item.title, className: "menu__text" + ("/" + route === item.link ? "-active" : "") },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: item.link },
	                  item.title
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "mobile_sidebar " + (isScrolled ? "mobile_sidebar--scrolled" : "") },
	          _react2.default.createElement(
	            "div",
	            { className: "logo" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              _react2.default.createElement("img", { src: LOGOS.mobile, alt: "BMC Logo", className: "logo-img" })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "hmb", onClick: _this.toggleSidebar },
	            _react2.default.createElement("i", { className: "fa fa-bars" })
	          ),
	          _react2.default.createElement(_Sidebar2.default, { show: _this.state.isShowSidebar, Menu: NAVIGATION_MENU, onHide: _this.toggleSidebar, activePathname: route })
	        )
	      );
	    };
	
	    _this.renderFooter = function () {
	      var footerContent = _react2.default.createElement(
	        "div",
	        { className: "middle__content" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "b",
	            null,
	            "BAWA MASALA COMPANY"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          null,
	          "B-11, Lawrence Road, Industrial Area, New Delhi - 110 035"
	        )
	      );
	
	      return _react2.default.createElement(
	        "main",
	        null,
	        _react2.default.createElement(
	          "div",
	          { className: "page-layout__viewport__footer_content" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-3 col-sm-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "left__content" },
	                _react2.default.createElement("i", { className: "fa fa-copyright" }),
	                " Bawa Masala Company ",
	                new Date().getFullYear(),
	                ". All Rights Reserved"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6 col-sm-6" },
	              footerContent
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-3 col-sm-3" },
	              _react2.default.createElement(
	                "div",
	                { className: "right__content" },
	                "Powered By",
	                " ",
	                _react2.default.createElement(
	                  "a",
	                  { href: "http://blackelephantdigital.com", target: "_blank", rel: "noopener noreferrer" },
	                  _react2.default.createElement("img", { alt: "Black Elephant Digital", src: LOGOS.footer })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "page-layout__viewport__footer_content_mobile" },
	          footerContent,
	          _react2.default.createElement(
	            "div",
	            { className: "left__content" },
	            _react2.default.createElement("i", { className: "fa fa-copyright" }),
	            "Bawa Masala Company ",
	            new Date().getFullYear(),
	            ". All Rights Reserved"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "right__content" },
	            "Powered By",
	            " ",
	            _react2.default.createElement(
	              "a",
	              { href: "http://blackelephantdigital.com", target: "_blank", rel: "noopener noreferrer" },
	              _react2.default.createElement("img", { alt: "Black Elephant Digital", src: LOGOS.footer })
	            )
	          )
	        )
	      );
	    };
	
	    _this.renderSocialSidebar = function () {
	      return _react2.default.createElement(
	        "div",
	        { className: "page-layout__viewport__social__sidebar" },
	        _react2.default.createElement(
	          "div",
	          { className: "social__icons" },
	          SOCIAL_LINKS.map(function (social, index) {
	            return _react2.default.createElement(
	              "span",
	              { key: index, className: "icon" },
	              _react2.default.createElement(
	                "a",
	                { rel: "noopener noreferrer", href: social.url, target: "_blank", "aria-label": "Visit our " + social.icon.replace("fa-", "") + " page" },
	                _react2.default.createElement("i", { className: "fa-brands " + social.icon })
	              )
	            );
	          })
	        )
	      );
	    };
	
	    _this.state = {
	      isShowSidebar: false,
	      cartNumber: 0,
	      findingRegion: true,
	      show: false,
	      isSubmittingEmail: false,
	      subscriberEmail: "",
	      emailError: false,
	      isSubmitted: false,
	      isScrolled: false,
	      // Enquiry form state
	      showEnquiryForm: false,
	      isSubmittingEnquiry: false,
	      enquiryForm: {
	        fullName: "",
	        mobile: "",
	        address: "",
	        purpose: "",
	        message: ""
	      },
	      enquiryErrors: {},
	      enquirySubmitted: false
	    };
	    _this.regionName = "Delhi";
	    return _this;
	  }
	
	  PageLayout.prototype.componentDidMount = function componentDidMount() {
	    this.initializePixelTracking();
	    this.initializeCart();
	    this.checkPopupDisplay();
	    this.fetchUserLocation();
	    this.addScrollListener();
	    this.showEnquiryFormDelayed();
	  };
	
	  PageLayout.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.removeScrollListener();
	  };
	
	  // Enquiry form methods
	
	
	  PageLayout.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        location = _props.location;
	    var isScrolled = this.state.isScrolled;
	
	    var route = location.pathname.split("/")[1];
	    var appChildren =  true ? children({ location: location }) : children();
	
	    return _react2.default.createElement(
	      _reactRedux.Provider,
	      { store: store },
	      _react2.default.createElement(
	        "div",
	        { className: "page-layout__viewport", style: { paddingTop: "0" } },
	        this.renderSocialSidebar(),
	        this.renderHeader(route),
	        _react2.default.createElement(
	          "div",
	          { className: "page-layout__viewport__middle_content " + (this.state.isScrolled ? "page-layout__viewport__middle_content--scrolled" : "") },
	          appChildren
	        ),
	        this.renderFooter(),
	        this.renderEnquiryPopup()
	      )
	    );
	  };
	
	  return PageLayout;
	}(_react2.default.Component);
	
	PageLayout.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  location: _propTypes2.default.object.isRequired
	};
	
	exports.default = PageLayout;

/***/ }),

/***/ 622:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _redux = __webpack_require__(406);
	
	var _productListConstant = __webpack_require__(42);
	
	var reducer = function reducer(state, action) {
		console.info("--------------------");
		console.info("\x1b[36m", "prev state -> ", state);
		console.info("\x1b[36m", "action", action);
		var _state = state,
		    meta = _state.products.meta;
	
		if (meta.isFetching) {
			// console.log("ProductList", ProductList)
			var list = [].concat(_productListConstant.SpiceDetails, _productListConstant.DhoopDetails, _productListConstant.Misc);
			var listItemById = {};
			var uIdListItemById = {};
			var wholeMasalas = [];
			var blendedMasalas = [];
			var specialities = [];
			var pujaMaterials = [];
			list.map(function (item) {
				var _extends2;
	
				if (uIdListItemById[item.u_id] === undefined || uIdListItemById[item.u_id] === null) {
					uIdListItemById[item.u_id] = [];
				}
				// if (listItemById[item.id] === undefined || listItemById[item.id] === null) {
				// 	listItemById[item.id] = {}
				// }
				if (item.ingredients === "1" && item.type_id === "Spices") {
					wholeMasalas.push(item);
				} else if (item.type_id === "Spices") {
					blendedMasalas.push(item);
				}
				if (item.type_id === "Misc") {
					specialities.push(item);
				} else if (item.type_id === "Dhoop") {
					pujaMaterials.push(item);
				}
				uIdListItemById[item.u_id].push(item);
				listItemById = _extends({}, listItemById, (_extends2 = {}, _extends2[item.id] = item, _extends2));
				uIdListItemById[item.u_id].sort(function (a, b) {
					return a.mrp - b.mrp;
				});
				// console.log("uIdListItemById", uIdListItemById)
			});
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					list: list,
					listItemById: listItemById,
					uIdListItemById: uIdListItemById,
					wholeMasalas: wholeMasalas,
					blendedMasalas: blendedMasalas,
					specialities: specialities,
					pujaMaterials: pujaMaterials,
					meta: {
						isFetching: false
					}
				})
			});
		}
	
		if (action.type === "INCREMENT") {
			state = _extends({}, state, {
				count: state.count + action.index
			});
			// return state
		}
		if (action.type === "FETCHED_USER_DATA") {
			state = _extends({}, state, {
				user: action.user
			});
			// return state
		}
		if (action.type === "FETCHED_PRODUCT_LIST") {
			var _list = action.list;
	
			var _listItemById = {};
			var _uIdListItemById = {};
			var _wholeMasalas = [];
			var _blendedMasalas = [];
			var _specialities = [];
			var _pujaMaterials = [];
			_list.map(function (item) {
				var _extends3;
	
				_uIdListItemById = _extends({}, _uIdListItemById, (_extends3 = {}, _extends3[item.u_id] = item, _extends3));
				if (_listItemById[item.id] === undefined || _listItemById[item.id] === null) {
					_listItemById[item.id] = [];
				}
				if (item.ingredients === "1" && item.type_id === "Spices") {
					_wholeMasalas.push(item);
				} else if (item.type_id === "Spices") {
					_blendedMasalas.push(item);
				}
				if (item.type_id === "Misc") {
					_specialities.push(item);
				} else if (item.type_id === "Dhoop") {
					_pujaMaterials.push(item);
				}
				_listItemById[item.id].push(item);
			});
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					list: _list,
					listItemById: _listItemById,
					uIdListItemById: _uIdListItemById,
					wholeMasalas: _wholeMasalas,
					blendedMasalas: _blendedMasalas,
					specialities: _specialities,
					pujaMaterials: _pujaMaterials,
					meta: {
						isFetching: false
					}
				})
			});
			// return state
		}
		if (action.type === "SET_TO_CART") {
			var addToCartList = action.addToCartList;
	
			state = _extends({}, state, {
				addToCartList: _extends({}, addToCartList, {
					isAddToCartChange: !state.addToCartList.isAddToCartChange
				})
			});
		}
		if (action.type === "ADD_TO_CART") {
			var _list2 = action.list;
	
			state = _extends({}, state, {
				products: _extends({}, state.products, {
					cart: _list2,
					cartChange: !state.products.isCartChange
				})
			});
		}
		if (action.type === "SET_MACHINE_ADDRESS") {
			var ipData = action.ipData;
	
			state = _extends({}, state, {
				ipData: ipData
			});
		}
		console.info("\x1b[36m", "next state -> ", state);
		console.info("--------------------");
		// state = { ...stateObj }
		return state;
	};
	
	var initialState = {
		count: 0,
		user: {},
		addToCartList: { products: {}, totalNumber: 0, isAddToCartChange: false },
		products: { list: [], meta: { isFetching: true }, cart: {}, cartChange: false },
		ipData: {}
	};
	
	var createStore = function createStore() {
		return (0, _redux.createStore)(reducer, initialState);
	};
	exports.default = createStore;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-jsx-984a1b0082643387eae4.js